import { Component } from '@angular/core';
import { AsyncPipe } from '@angular/common';

import { Store } from '@ngrx/store';

import { SideBarMenuComponent } from '@app/components/header/components/side-bar-menu/side-bar-menu.component';
import { appFeature } from '@app/core/store/app.reducer';

import { userRoles } from '@app/core/store/app.selectors';
import { CompanyStatus } from '@app/shared/enums';

@Component({
  selector: 'app-user-popup-menu',
  imports: [SideBarMenuComponent, AsyncPipe],
  templateUrl: './user-popup-menu.component.html',
  styleUrl: './user-popup-menu.component.scss'
})
export class UserPopupMenuComponent {
  public user$ = this.store.select(appFeature.selectUser);
  public userRoles$ = this.store.select(userRoles);

  public isSideBarMenuOpened = false;

  public readonly companyStatusBlocked = CompanyStatus.Blocked;

  constructor(private store: Store) {}

  public closeSideBarMenu(): void {
    this.isSideBarMenuOpened = false;
  }

  public toggleSideBarMenuOpen(): void {
    this.isSideBarMenuOpened = !this.isSideBarMenuOpened;
  }
}
